var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip)?_c('vx-tooltip',{staticClass:"tooltip vx-action-icon",attrs:{"color":_vm.dynamicPopoverColor,"text":_vm.tooltip,"position":_vm.tooltipPosition,"delay":".1s"}},[_c('vx-basic-icon',_vm._g({staticClass:"custom-action-icon",class:[
            { disabled: _vm.disabled },
            { active: _vm.active },
            { grow: _vm.growWhenActive },
            { spin: _vm.spin }
        ],attrs:{"icon":_vm.dynamicIcon,"size":_vm.size,"filled":_vm.filled,"rounded":_vm.rounded,"color":_vm.dynamicColor},on:{"mouseover":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},_vm.$listeners))],1):_c('vx-basic-icon',_vm._g({staticClass:"custom-action-icon vx-action-icon",class:[
        { disabled: _vm.disabled },
        { active: _vm.active },
        { grow: _vm.growWhenActive },
        { spin: _vm.spin }
    ],attrs:{"icon":_vm.dynamicIcon,"size":_vm.size,"filled":_vm.filled,"rounded":_vm.rounded,"color":_vm.dynamicColor},on:{"mouseover":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }